import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    apiVersion: '',
    appName: 'ArchivoX',
    breadcrumbItems: [],
    commandBarFarItems: [],
    commandBarItems: [],
    isNavCollapsed: false,
    navItems: [],
    notifications: [],
    searchBoxPlaceholder: 'Search...',
    showBreadcrumb: false,
    showSearchBox: false,
    tenantUrl: '',
    tutorials: [],
    uiVersion: '',
    userMenuItems: [],
    search: '',
    themeName: 'light'
};
export const layoutSlice = createSlice({
    name: 'layout',
    initialState: initialState,
    reducers: {
        setIBreadcrumbItemItems: (state, action) => {
            state.breadcrumbItems = action.payload || [];
        },
        setNavItems: (state, action) => {
            state.navItems = action.payload || [];
        },
        setNavItem: (state, action) => {
            const navItem = action.payload;
            const findInLevel = (level) => {
                level.forEach(item => {
                    if (item.key === navItem.key) {
                        item.isExpanded = navItem.isExpanded;
                    }
                    if (item.links) {
                        findInLevel(item.links);
                    }
                });
            };
            findInLevel(state.navItems);
        },
        setNotifications: (state, action) => {
            state.notifications = action.payload || [];
        },
        toggleNavCollapsed: (state) => {
            state.isNavCollapsed = !state.isNavCollapsed;
            localStorage.setItem('isNavCollapsed', state.isNavCollapsed ? '1' : '0');
        },
        setAppName: (state, action) => {
            state.appName = action.payload || '';
        },
        setTutorials: (state, action) => {
            state.tutorials = action.payload || [];
        },
        setTenantUrl: (state, action) => {
            state.tenantUrl = action.payload || '';
        },
        setUserMenuItems: (state, action) => {
            state.userMenuItems = action.payload || [];
        },
        setCommandBarItems: (state, action) => {
            state.commandBarItems = action.payload || [];
        },
        setCommandBarFarItems: (state, action) => {
            state.commandBarFarItems = action.payload || [];
        },
        setUiVersion: (state, action) => {
            state.uiVersion = action.payload || '';
        },
        setApiVersion: (state, action) => {
            state.apiVersion = action.payload || '';
        },
        setShowBreadcrumb: (state, action) => {
            state.showBreadcrumb = action.payload || false;
        },
        setShowSearchBox: (state, action) => {
            state.showSearchBox = action.payload || false;
        },
        setSearchBoxPlaceholder: (state, action) => {
            state.searchBoxPlaceholder = action.payload || '';
        },
        setMessage: (state, action) => {
            state.message = action.payload || '';
        },
        setSearch: (state, action) => {
            state.search = action.payload || '';
        },
        setThemeName: (state, action) => {
            state.themeName = action.payload || '';
        }
    }
});
